import { useEffect } from 'react';

/**
 * @param {()=>React.ReactElement | React.ReactElement} getElement an element or a function to get the element whose 'scroll' event will be listened to
 * @param {() => void} callback will be called when reach the element's bottom
 * @param {boolean} boolean whether `callback` should be called,could be used to set a condition to stop pulling data
 */
export default function useScrollReachBottom(getElement, callback, boolean) {
  useEffect(() => {
    const element = typeof getElement === 'function' ? getElement() : getElement;

    if (boolean && element) {
      if (
        element.clientHeight > 0 &&
        element.scrollHeight > 0 &&
        element.scrollHeight === element.clientHeight
      ) {
        callback();
      } else {
        const handler = () => {
          const { scrollHeight, clientHeight, scrollTop } = element;
          const toBottom = scrollHeight - scrollTop - clientHeight;
          if (toBottom <= 100) {
            callback();
          }
        };

        element.addEventListener('scroll', handler);

        return () => {
          if (element) {
            element.removeEventListener('scroll', handler);
          }
        };
      }
    }
    return () => {};
  }, [boolean, callback, getElement]);
}
